import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import Customer from '../model/Customer'
import { PolicyDtoRead } from '../model/PolicyDtoRead'
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";
import { CommonUtility } from '../../Services/CommonUtility';
import { PolicyLOBReadDto } from '../model/PolicyLOBReadDto';
import { PolicyLocationReadDto } from '../model/PolicyLocationReadDto';
import { PolicyVehicleDto } from '../model/PolicyVehicleDto';
import { SelectOption } from "../../shared/components/input/SelectOption";

type PolicyDetailsMap = {
    [key: string]: PolicyDtoRead | null;
};

interface CustomerState {
    customer: Customer,
    policies: PolicyDtoRead[],
    policiesForDropdown: SelectOption[],
    isFetchingPolicyList: boolean,
    customerSummary: CustomerFilterViewMoel | null;
    selectedPolicyDetails: PolicyDetailsMap;
    policyId?: string;
    polEventId?: string;
    lobDetails: PolicyLOBReadDto[];
    selectedLocationDetails: PolicyLocationReadDto | null;
    selectedVehicleDetails: PolicyVehicleDto | null;
    selectedLOBDetails: PolicyLOBReadDto | null;
}

const initialState: CustomerState = {
    customer: {},
    policies: [],
    policiesForDropdown:[],
    isFetchingPolicyList: false,
    customerSummary: null,
    selectedPolicyDetails: {},
    policyId: undefined,
    polEventId: undefined,
    lobDetails: [],
    selectedLocationDetails: null,
    selectedVehicleDetails: null,
    selectedLOBDetails: null
}

const getPolicyDetailKey = (policyId: string, polEventId: string) => CommonUtility.getPolicyDetailKey(policyId, polEventId);

const customerSlice = createSlice({
    name: "customers",
    initialState,
    reducers: {
        updateCustomers(state, action: PayloadAction<Customer>) {
            const customers = action.payload;
            state.customer = customers;

        },
        storeCustomerPolicies(state, action: PayloadAction<PolicyDtoRead[]>) {
            {
                const policies = action.payload;
                state.policies = policies;
                state.isFetchingPolicyList = false;
            }
        },
        startFetchingCustomerPolicies(state) {
            {
                state.isFetchingPolicyList = true;
            }
        },
        setCustomerSummary(state, action: PayloadAction<CustomerFilterViewMoel>) {
            {
                const customerSummary = action.payload;
                state.customerSummary = customerSummary;
            }
        },
        updateSelectedPolicyDetails(state, action: PayloadAction<{ policyId: string, polEventId: string, policyDetails: PolicyDtoRead | null }>) {
            const { policyId, polEventId, policyDetails } = action.payload;
            const key = getPolicyDetailKey(policyId, polEventId);
            state.selectedPolicyDetails[key] = policyDetails;
            state.policyId = policyId;
            state.polEventId = polEventId;
        },
        updateLocationDetails(state, action: PayloadAction<PolicyLocationReadDto | null>) {
            const locationDetails = action.payload;
            state.selectedLocationDetails = locationDetails;
        },
        updateVehicleDetails(state, action: PayloadAction<PolicyVehicleDto | null>) {
            const vehicleDetails = action.payload;
            state.selectedVehicleDetails = vehicleDetails;
        },
        updateSelectedLOBDetails(state, action: PayloadAction<PolicyLOBReadDto | null>) {
            const selectedLOBDetails = action.payload;
            state.selectedLOBDetails = selectedLOBDetails;
        },
        storeCustomerPoliciesForDropdown(state, action: PayloadAction<SelectOption[]>) {
            const policiesForDropdown = action.payload;
            state.policiesForDropdown = policiesForDropdown;
        }

    }
})

export const { updateCustomers, storeCustomerPolicies, startFetchingCustomerPolicies, setCustomerSummary, updateSelectedPolicyDetails, updateLocationDetails, updateVehicleDetails, updateSelectedLOBDetails, storeCustomerPoliciesForDropdown } = customerSlice.actions;
export default customerSlice.reducer;